module.exports = __webpack_public_path__ + "static/media/Profile4.b3856fb8.svg";